export function ReferenceInput() {
    return null;
}
